export default class TransferInteractionConfiguration {
  enableComments: 'disabled' | 'oneway' | 'twoway' = 'disabled'; //Only twoway (visible for all parties) supported for now!
  needsNameEntered: boolean = false;
  approvalEnabled: boolean = false;
  symmetricInteractionKey: string | null = null;
}
